import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, Mail } from "lucide-react";
import LoadingOverlay from "../LoadingOverlay";
import Typography from "../Typography";

const MONTHS = [
  "Gennaio",
  "Febbraio",
  "Marzo",
  "Aprile",
  "Maggio",
  "Giugno",
  "Luglio",
  "Agosto",
  "Settembre",
  "Ottobre",
  "Novembre",
  "Dicembre",
];

function prevMonth(year: number, month: number) {
  return month === 1
    ? { year: year - 1, month: 12 }
    : { year, month: month - 1 };
}

function nextMonth(year: number, month: number) {
  return month === 12
    ? { year: year + 1, month: 1 }
    : { year, month: month + 1 };
}

type CalendarMonthNavProps = {
  isLoading?: boolean;
  month: number;
  year: number;
  onMonthChange: (year: number, month: number) => void;
  onCompileReport?: (year: number, month: number) => void;
};

export default function CalendarMonthNav({
  isLoading = false,
  year,
  month,
  onMonthChange,
  onCompileReport,
}: CalendarMonthNavProps) {
  const handlePrev = () => {
    const prev = prevMonth(year, month);
    onMonthChange(prev.year, prev.month);
  };

  const handleNext = () => {
    const next = nextMonth(year, month);
    onMonthChange(next.year, next.month);
  };

  return (
    <div className="CalendarMonthNav">
      <Typography variant="h2">
        {MONTHS[month - 1]} {year}
        {isLoading && <LoadingOverlay />}
      </Typography>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="icon" onClick={handlePrev} aria-label="Mese precedente">
          <ChevronLeft className="h-5 w-5" />
        </Button>
        <Button variant="ghost" size="icon" onClick={handleNext} aria-label="Mese successivo">
          <ChevronRight className="h-5 w-5" />
        </Button>
        {onCompileReport && (
          <Button
            variant="ghost"
            size="icon"
            disabled={isLoading}
            onClick={() => onCompileReport(year, month)}
            aria-label="Invia report"
          >
            <Mail className="h-5 w-5" />
          </Button>
        )}
      </div>
    </div>
  );
}
